<template>
  <div class="section-dashboard">
    <router-link to="/home" class="back-link">
      <el-icon><ArrowLeft /></el-icon>
      {{ t('menu.home') }}
    </router-link>
    <h2 class="section-title">{{ sectionTitle }}</h2>
    <div class="cards-grid">
      <router-link
        v-for="child in children"
        :key="child.path"
        :to="child.path"
        class="card-link"
      >
        <el-card class="nav-card" shadow="hover">
          <div class="nav-card-body">
            <el-icon v-if="child.icon && iconMap[child.icon]" class="nav-card-icon">
              <component :is="iconMap[child.icon]" />
            </el-icon>
            <span class="nav-card-title">{{ t(child.i18nKey) }}</span>
          </div>
        </el-card>
      </router-link>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'
import { computed } from 'vue'
import {
  ArrowLeft,
  HomeFilled,
  Document,
  Odometer,
  Calendar,
  Location,
  Apple,
  Compass,
  Grid,
  Collection,
  Monitor,
} from '@element-plus/icons-vue'
import { sectionChildrenByPath, mainNavSections } from '../config/navigation'

const { t } = useI18n()
const route = useRoute()

const children = computed(() => {
  const path = route.path
  return sectionChildrenByPath[path] ?? []
})

const sectionTitle = computed(() => {
  const path = route.path
  const section = mainNavSections.find((s) => s.path === path)
  return section ? t(section.i18nKey) : path
})

const iconMap: Record<string, unknown> = {
  HomeFilled,
  Document,
  Odometer,
  Calendar,
  Location,
  Apple,
  Compass,
  Grid,
  Collection,
  Monitor,
}
</script>

<style scoped>
.section-dashboard {
  max-width: 1200px;
  margin: 0 auto;
}

.back-link {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 1rem;
  color: #409eff;
  text-decoration: none;
  font-size: 0.95rem;
}

.back-link:hover {
  text-decoration: underline;
}

.section-title {
  margin-bottom: 1.5rem;
  font-size: 1.35rem;
  color: #303133;
}

.cards-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 1rem;
}

.card-link {
  text-decoration: none;
  color: inherit;
}

.nav-card {
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
}

.nav-card:hover {
  transform: translateY(-2px);
}

.nav-card-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.75rem;
  padding: 0.5rem;
}

.nav-card-icon {
  font-size: 1.75rem;
  color: #409eff;
}

.nav-card-title {
  font-size: 0.9rem;
  text-align: center;
  font-weight: 500;
}

@media (max-width: 768px) {
  .cards-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
</style>
